<template lang="pug">
.v-text-banner.text-banner(v-if="banner" :style="{'background-color': banner.backgroundColor}")
	img.text-banner__icon(v-if="banner.icon" :src="banner.icon" alt="" loading="lazy")
	.text-banner__text(v-if="banner.text") {{banner.text}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';


export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			banner: null
		};
	},

	methods: {
		dataSet(data) {
			this.banner = data;
		}
	}
};
</script>